import ImageFilter from '@/typings/ImageFilter';

(function () {
    'ngInject';

    angular.module('app.shared.services').factory('CustomilyImageFilterService', CustomilyImageFilterService);

    function CustomilyImageFilterService(
        blockUI,
        CustomilyImageFilterAPIService,
        MultipleFileUploadService,
        $window,
        $mdDialog,
        $timeout
    ) {
        async function applyFilter(object = null, filter = ImageFilter.DEFAULT, $scope, canvas) {
            const targetObject = object || $scope.imageSelected;

            if (!targetObject.imageFile) return;

            const blockUIMessage = 'Applying filter...';
            blockUI.start(blockUIMessage);

            try {
                const response = await CustomilyImageFilterAPIService.applyFilter(targetObject.imageFile, filter);
                targetObject.oldCustomilyImageFilterFile = targetObject.imageFile;
                targetObject.imageFile = response;
                await MultipleFileUploadService.uploadMultipleImages($scope, canvas, [response], targetObject);
            } catch (error) {
                window.rumReportError(error);
                targetObject.oldCustomilyImageFilterFile = null;
                $timeout(() => $scope.$apply());
                $mdDialog.showCommonError(
                    error,
                    'There seems to be an error with our image filter. Please contact our support team.',
                    'Image filter error' + (error.statusText ? ': ' + error.statusText : '!')
                );
            } finally {
                $scope.$apply(() => blockUI.stop());
            }
        }

        return {
            applyFilter
        };
    }
})();
